import { defaultParams } from 'types/pageParams/PageParams'

export const regexHaveCountryAndLanguage =
	/^\/[a-zA-Z]{2}(-[a-zA-Z0-9]{2,3})?.*$/
export const defaultCountry = defaultParams.country
export const defaultLanguage = defaultParams.language
